import startCase from 'lodash/startCase'

const ProperCase = ({ value }) => {
  return value
    .split(',')
    .map((part, i, arr) => (i < arr.length - 1 ? startCase(part.toLowerCase()) : part).trim())
    .join(', ')
}

export default ProperCase
